import $ from 'jquery'
import '../public/static/js/select2.min.js'

window.$ = window.jQuery = $

export default $
